export default __webpack_public_path__ + "36a9c733df3665ead0e7718e6da55c38.jpg";